
import Component from 'vue-class-component';
import { Mixins } from 'vue-property-decorator';
import NavMeetingsMixin from '@/core/mixins/nav-meetings.mixin';

@Component({
  name: 'ed-nav-meetings'
})
export default class EdNavMeetings extends Mixins(NavMeetingsMixin) {

  public navMenuID: string = 'EdNavMeetings';

}